/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$violator-carrier-width-small: 68px !default;
$violator-carrier-height-small: 68px !default;
$violator-carrier-padding-small: 8px !default;
$violator-carrier-radius-small: 8px !default;

$violator-carrier-width: 80px !default;
$violator-carrier-height: 80px !default;
$violator-carrier-padding: 10px 12px !default;
$violator-carrier-radius: 12px !default;

$violator-carrier-width-xlarge: 112px !default;
$violator-carrier-height-xlarge: 112px !default;
$violator-carrier-padding-xlarge: 20px 16px !default;
$violator-carrier-radius-xlarge: 16px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: inline-block;
  @include eon-typography();

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}inner {
  position: relative;
  width: $violator-carrier-width;
  height: $violator-carrier-height;
  padding: $violator-carrier-padding;
  color: v(textColor);
  font-family: $font-family-base;
  display: block;
  overflow: hidden;

  .#{$prefix}background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    &.#{$prefix}icon-no-svg {
      background-color: v(backgroundColor);
      border-radius: $violator-carrier-radius;
    }

    &:not(.#{$prefix}icon-no-svg) {
      fill: v(backgroundColor);
    }
  }

  .#{$prefix}content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 2;

    &.#{$prefix}py-top {
      justify-content: flex-start;
    }

    &.#{$prefix}py-center {
      justify-content: center;
    }

    &.#{$prefix}py-bottom {
      justify-content: flex-end;
    }

    &.#{$prefix}t-left {
      align-items: flex-start;
      text-align: left;
    }

    &.#{$prefix}t-center {
      align-items: center;
      text-align: center;
    }

    &.#{$prefix}t-right {
      align-items: flex-end;
      text-align: right;
    }

    &.#{$prefix}pictogram-center {
      align-items: center;
      justify-content: center;
    }
  }

  .#{$prefix}line {
    position: relative;
    width: 100%;
    height: auto;
    display: block;
    z-index: 2;
    white-space: nowrap;
    overflow: hidden;

    &.#{$prefix}fs-small {
      font-size: 14px;
      line-height: 16px;
    }

    &.#{$prefix}fs-normal {
      font-size: 18px;
      line-height: 20px;
    }

    &.#{$prefix}fs-large {
      font-size: 22px;
      line-height: 24px;
    }

    &.#{$prefix}ft-regular {
      font-weight: $font-weight-regular;
    }

    &.#{$prefix}ft-bold {
      font-weight: $font-weight-bold;
    }
  }

  &.#{$prefix}small {
    width: $violator-carrier-width-small;
    height: $violator-carrier-height-small;
    padding: $violator-carrier-padding-small;

    .#{$prefix}background {
      &.#{$prefix}icon-no-svg {
        border-radius: $violator-carrier-radius-small;
      }
    }

    .#{$prefix}line {
      &.#{$prefix}fs-small {
        font-size: 12px;
        line-height: 14px;
      }

      &.#{$prefix}fs-normal {
        font-size: 14px;
        line-height: 16px;
      }

      &.#{$prefix}fs-large {
        font-size: 22px;
        line-height: 24px;
      }
    }
  }

  &.#{$prefix}xlarge {
    width: $violator-carrier-width-xlarge;
    height: $violator-carrier-height-xlarge;
    padding: $violator-carrier-padding-xlarge;

    .#{$prefix}background {
      &.#{$prefix}icon-no-svg {
        border-radius: $violator-carrier-radius-xlarge;
      }
    }

    .#{$prefix}line {
      &.#{$prefix}fs-small {
        font-size: 14px;
        line-height: 16px;
      }

      &.#{$prefix}fs-normal {
        font-size: 20px;
        line-height: 24px;
      }

      &.#{$prefix}fs-large {
        font-size: 26px;
        line-height: 26px;
      }
    }
  }

  @include for-size(phone) {
    width: $violator-carrier-width-small;
    height: $violator-carrier-height-small;
    padding: $violator-carrier-padding-small;

    .#{$prefix}line {
      &.#{$prefix}fs-small {
        font-size: 12px;
        line-height: 14px;
      }

      &.#{$prefix}fs-normal {
        font-size: 14px;
        line-height: 16px;
      }

      &.#{$prefix}fs-large {
        font-size: 22px;
        line-height: 24px;
      }
    }
  }
}

::slotted(*) {
  color: v(textColor);
}
